import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/reducers';

export interface TagSliceState {
  nextDisplayOrder: number;
}

const initialState: TagSliceState = {
  nextDisplayOrder: 1
};

export const tagSlice = createSlice({
  name: 'tag',
  initialState,
  reducers: {
    resetTagSlice: () => initialState,
    setNextDisplayOrder: (state, action: PayloadAction<number>) => {
      state.nextDisplayOrder = action.payload;
    }
  }
});

export const { resetTagSlice, setNextDisplayOrder } = tagSlice.actions;

export const selectNextDisplayOrder = (state: RootState) => state.rootReducer.tag.nextDisplayOrder;

export default tagSlice.reducer;
